import { Pipe, PipeTransform } from '@angular/core';


export enum AccountType {
	MY_ACCOUNTS = 1,
	THIRD_PARTY = 2
}

export namespace AccountType {

	export function getTitle(type: AccountType): string {
		return Object.keys(AccountType).find(key => AccountType[key] === type);
	}

}


@Pipe({
	name: 'accountTypeText',
	standalone: true
})
export class AccountTypeTextPipe implements PipeTransform {

	accountType = AccountType;

	transform(value: AccountType): any {
		return this.accountType.getTitle(value);
	}
}
